import { BadgePercent, Headphones, RefreshCw, Sparkles } from 'lucide-react';
import { useAirlineLanding } from '../AirlineContext';

const ICONS = {
  deals: BadgePercent,
  help: Headphones,
  book: RefreshCw,
};

export default function SwHero() {
  const { hero } = useAirlineLanding();

  return (
    <section className="swp-hero" id="swp-top">
      <div className="swp-shell">
        <div className="swp-hero__grid">
          <div>
            <span className="swp-hero__badge">
              <Sparkles size={14} aria-hidden />
              {hero.badge}
            </span>

            <p className="swp-hero__kicker">{hero.titleLead}</p>
            <h1>{hero.title}</h1>
          </div>

          <div className="swp-hero__art">
            <img
              src="/images/airplane.jpg"
              alt="Commercial aircraft climbing after take-off"
              width="640"
              height="420"
              fetchPriority="high"
              decoding="async"
            />
          </div>
        </div>

        <ul className="swp-hero__features">
          {hero.chips.map((chip) => {
            const Icon = ICONS[chip.icon] ?? BadgePercent;
            return (
              <li key={chip.label}>
                <span className="swp-hero__icon">
                  <Icon size={18} aria-hidden />
                </span>
                <span>
                  <strong>{chip.label}</strong>
                  {chip.sub ? <small>{chip.sub}</small> : null}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
